import {AppConfig} from "../AppConfig";
import Util from "@/Master/Util";
import packageJson from "../../../../package.json";
const config:AppConfig = {
    productId: 70055,
    releaseProductId: 70055,

    productVersion: '_PWA_VERSION_',//动态生成的版本号

    ia_host: "us.gogogoldwin.com",
    privacy_url: "http://evolvegrouplimited.com/privacy.html",
    trems_url: "http://evolvegrouplimited.com/terms.html",
    sweepstakes_rules_url: "http://evolvegrouplimited.com/clover/sweepsrules.html",
    responsible_play_url: "http://evolvegrouplimited.com/clover/responsible.html",
    game_statement: "http://evolvegrouplimited.com/clover/gamestatement.html    ",
    mail: "contact@gogogoldwin.com",

    game_api_url: "https://mania.gogogoldwin.com",
    nat_host: "mania.gogogoldwin.com",

    h5_version_code: packageJson.version_core,
    h5_version_name: packageJson.version,
    h5_app_name: packageJson.name,
    h5_package_name: "gogogoldwin.com",
    h5_host_name: Util.isWindow ? encodeURIComponent(window.location.host) : '',

    h5_mode: 1,//0默认PWA模式 1直接进入游戏模式
    h5_res_host: "https://remars.goldcasinofun.com/GoldenCloverSimpleH5/",
    h5_res_ver: "webgl/version_8/",

    GTM_ID: "GTM-WS59ZGP2",

    sm_businessId: "h5_vxozpcpsms",
    sm_apiKey: "un8tx6z8hxm5wetsl8rvfy23t9vvrj4ah2b4",
};

export default config; // 确保有默认导出
